import React from 'react'
import { SummaryQuantity } from './SummaryWmo.css'

const SummaryQuantityWmo: React.FC<{quantity: number}> = ({ quantity }) => (
  <SummaryQuantity>
    {quantity > 1
      ? `(${quantity} Items)`
      : `(${quantity} Item)`}
  </SummaryQuantity>
)

export default SummaryQuantityWmo
